import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Tabs, Tab } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { BaseWeekDto } from "@growth-machine-llc/stridist-api-client";
import LinearLoader from "../loading/LinearLoader/LinearLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },

  tabs: {
    "& .Mui-disabled": {
      display: "none",
    },
  },

  tab: {
    fontWeight: 700,
    color: theme.palette.text.secondary,
    flexGrow: 1,

    minWidth: 253,
    maxWidth: "100%",

    [theme.breakpoints.down("md")]: {
      minWidth: 156,
    },

    [theme.containerQueries.down("md")]: {
      minWidth: 156,
    },
  },

  selected: {
    color: theme.palette.primary.main,
  },

  current: {
    "&:not($selected)": {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.selected.main,
    },
  },
}));

export interface ClientProgramTimelineProps extends Omit<BoxProps, "onChange"> {
  weeks: BaseWeekDto[];
  currentWeek: number;
  selected: number;
  setSelected: (x: string) => void;
}

export function ClientProgramTimeline(props: ClientProgramTimelineProps) {
  const { className, weeks, currentWeek, selected, setSelected } = props;
  const s = useStyles();

  const handleChange = React.useCallback(
    (_, value: any) => {
      setSelected(value);
    },
    [setSelected],
  );

  return (
    <Box className={clsx(s.root, className)}>
      <Tabs
        className={s.tabs}
        value={selected}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        indicatorColor="primary"
        aria-label="scrollable force tabs example"
        allowScrollButtonsMobile
      >
        {weeks.map(({ weekNumber }, index) => {
          return (
            <Tab
              key={index}
              label={`Week ${weekNumber}`}
              value={weekNumber}
              className={clsx(s.tab, {
                [s.selected]: weekNumber === selected,
                [s.current]: weekNumber === currentWeek,
              })}
            />
          );
        })}
      </Tabs>
    </Box>
  );
}
